import React from 'react';
import { RenderOneMatchFoundNotPrimary } from './fragments/renderOneMatchFoundNotPrimary';
import { RenderOneMatchFoundToBeDesignated } from './fragments/renderOneMatchFoundToBeDesignated';
import { RenderOneMatchFoundDesignatedToSameBroker } from './fragments/renderOneMatchFoundDesignatedToSameBroker';
import { RenderMultipleRecords } from './fragments/renderMultipleRecords';
import { RenderNoRecordFound } from './fragments/renderNoRecordFound';


import { APPLICATION_STATUS_KEY, EDE_SEARCH_RESULTS_TYPE } from '../../constants/constants';


const EDESearchResults = ({ backToDashboard, edeSearchResult, becomeAOR, clearData, startNewApplication }) => {

    const {
        key,
        primaryHousehold
    } = edeSearchResult;
    const applicationStatus = primaryHousehold && primaryHousehold.applicationStatus;
    const ssn = primaryHousehold && primaryHousehold.ssn;

    let appStatus = Object.values(Object.fromEntries(Object.entries(APPLICATION_STATUS_KEY).filter(([code]) => code.includes(applicationStatus))))[0];


    const formatSocialSecurityNumber = (ssn) => {
        ssn = ssn.replace(/\D/g, '');
        ssn = ssn.replace(/^(\d{3})/, 'XXX-');
        ssn = ssn.replace(/-(\d{2})/, '-XX-');
        ssn = ssn.replace(/(\d)-(\d{4}).*/, '$1-$2');
        return ssn;
    };
    let maskedSSN = ssn ? formatSocialSecurityNumber(ssn) : undefined;

    switch(key) {
        case EDE_SEARCH_RESULTS_TYPE.ONE_MATCH_FOUND_NOT_DESIGNATED:
        case EDE_SEARCH_RESULTS_TYPE.ONE_MATCH_FOUND_DESIGNATED_TO_OTHER_BROKER:
        case EDE_SEARCH_RESULTS_TYPE.ONE_MATCH_FOUND_DESIGNATED_TO_ASSISTER:
        case EDE_SEARCH_RESULTS_TYPE.ONE_MATCH_FOUND_DESIGNATED_TO_OTHER_BROKER_TIED_TO_PARTNER:
        case EDE_SEARCH_RESULTS_TYPE.ONE_MATCH_FOUND_NOT_DESIGNATED_TIED_TO_PARTNER:
            return <RenderOneMatchFoundToBeDesignated { ...{ edeSearchResult, backToDashboard, becomeAOR, appStatus, maskedSSN }} />;
        case EDE_SEARCH_RESULTS_TYPE.ONE_MATCH_FOUND_NOT_PRIMARY:
            return <RenderOneMatchFoundNotPrimary { ...{ clearData , backToDashboard }} />;
        case EDE_SEARCH_RESULTS_TYPE.ONE_MATCH_FOUND_DESIGNATED_TO_SAME_BROKER:
            return <RenderOneMatchFoundDesignatedToSameBroker { ...{ clearData , backToDashboard }} />;
        case EDE_SEARCH_RESULTS_TYPE.MULTIPLE_MATCHES_FOUND:
            return <RenderMultipleRecords { ...{ clearData , backToDashboard }} />;
        case EDE_SEARCH_RESULTS_TYPE.NO_MATCH_FOUND:
            return <RenderNoRecordFound { ...{ clearData , startNewApplication }} />;
        default:
            return null;
    }





};

export default EDESearchResults;